module.exports = __webpack_public_path__ + "static/img/A (30).e6727578.png";